export const RETURN_STATUSES: string[] = ["R", "RA", "RI"];
export const NON_RETURN_STATUSES: string[] = ["V", "A", "I"];

const STATUS_DESCRIPTIONS: Record<string, string> = {
  V: "Valid",
  A: "Amended",
  I: "Invalid",
  R: "Return",
  RA: "Return-Amended",
  RI: "Return-Invalidated",
};

export type TcStatusOption = {
  label: string;
  value: string;
};

type TcStatusReference = {
  code_1?: unknown;
  description_1?: unknown;
};

const statusOptionLabel = (item: TcStatusReference): string => {
  const code = String(item.code_1 ?? "").trim().toUpperCase();
  const description = String(item.description_1 ?? "").trim();
  const friendly =
    STATUS_DESCRIPTIONS[code] ||
    (description && description.toUpperCase() !== code.toUpperCase()
      ? description
      : code);

  return `${friendly} (${code})`;
};

const buildOptions = (
  items: TcStatusReference[],
  allowedCodes: readonly string[]
): TcStatusOption[] => {
  const seen = new Set<string>();

  return items.reduce<TcStatusOption[]>((options, item) => {
    const code = String(item.code_1 ?? "").trim().toUpperCase();
    if (!allowedCodes.includes(code) || seen.has(code)) {
      return options;
    }

    seen.add(code);
    options.push({
      label: statusOptionLabel(item),
      value: code,
    });
    return options;
  }, []);
};

export const buildTcStatusOptions = (items: unknown) => {
  const references = Array.isArray(items) ? items : [];
  const returnReferences = [
    ...references,
    ...RETURN_STATUSES.map((code) => ({
      code_1: code,
      description_1: STATUS_DESCRIPTIONS[code],
    })),
  ];

  return {
    tcStatusOptions: buildOptions(references, NON_RETURN_STATUSES),
    // TCSTS in UAT currently exposes only V/A/I. Return statuses are a UI
    // contract, so append canonical fallbacks while preserving any reference
    // descriptions supplied by the API.
    returnTcStatusOptions: buildOptions(returnReferences, RETURN_STATUSES),
  };
};
